export default {
  NETSIS_FATURA_MUTATE(state, val) {
    state.secilenNetsisFaturaAktarim = val
  }, TOPLU_ISLEM_STOK_LISTESI(state, val) {
    state.secilenStokListTopluIslem = val
  }, MENU_LIST_FOR_TABS(state, val) {
    state.menuListForTabs = val
  },LOJISTIK_LIST_FOR_TABS(state, val) {
    state.lojistikList = val
  }, MENU_ITEM(state, val) {
    state.menuItem = val
  }, STOK_AKTAR_LIST(state, val) {
    state.stokAktarList = val
  }, FATURA_PAZARYERIVAL(state, val) {
    state.stokAktarList = val
  },MPSTOCKSTOCKID(state, val) {
    state.mpstockstokcid = val
  },
}